import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay,
  Avatar,
  Box,
  BoxProps,
  Button,
  CloseButton,
  Drawer,
  DrawerContent,
  Flex,
  FlexProps,
  HStack,
  Icon,
  IconButton,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  VStack,
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';
import React, { ReactNode, ReactText } from 'react';
import { CgGym } from "react-icons/cg";
import { IconType } from 'react-icons';
import { AiOutlineVideoCamera } from 'react-icons/ai';
import { BiCategoryAlt } from 'react-icons/bi';
import { FaFlagCheckered, FaMedal } from "react-icons/fa";
import {
  FiBell,
  FiChevronDown,
  FiHome,
  FiMenu,
  FiSettings
} from 'react-icons/fi';
import { IoIosRadio } from "react-icons/io";
import { MdNotifications, MdPeople } from "react-icons/md";
import CommonContext from '../commonContext';
import { GoPerson } from "react-icons/go";
import { MdOutlineSportsGymnastics } from "react-icons/md";
import { SiGooglesheets } from "react-icons/si";

interface CommonContextInterface {
  currentPath: String,
  currentPage: String,
}


interface LinkItemProps {
  name: string;
  icon: IconType;
  route: string;
}
const LinkItems: Array<LinkItemProps> = [
  { name: 'Home', icon: FiHome, route: "/home" },
  { name: 'Categorie', icon: BiCategoryAlt, route: "/categorieslist" },
  { name: 'Video', icon: AiOutlineVideoCamera, route: "/videolist" },
  { name: 'Utenti', icon: MdPeople, route: "/users" },
  { name: 'Competizioni', icon: FaFlagCheckered, route: "/competitions" },
  { name: 'Palmares', icon: FaMedal, route: "/palmares" },
  { name: 'Allenamenti', icon: MdOutlineSportsGymnastics, route: "/trainings" },
  { name: 'Schede', icon: SiGooglesheets, route: "/trainingsheets" },
  /* { name: 'Podcast', icon: IoIosRadio, route: "/podcast" }, */
  { name: 'Iscrizioni esterne', icon: GoPerson, route: "/externalusers" },
  { name: 'Notifiche', icon: MdNotifications, route: "/notifications" },
  { name: 'Impostazioni', icon: FiSettings, route: "/settings" },


];


export default function SidebarWithHeader({
  children,
}: {
  children: ReactNode;
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box minH="100vh" bg={useColorModeValue('gray.100', 'gray.900')}>
      <SidebarContent
        onClose={() => onClose}
        display={{ base: 'none', md: 'block' }}
      />
      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full">
        <DrawerContent>
          <SidebarContent onClose={onClose} />
        </DrawerContent>
      </Drawer>
      {/* mobilenav */}
      <MobileNav onOpen={onOpen} />
      <Box ml={{ base: 0, md: 60 }} p="0">
        {children}
      </Box>
    </Box>
  );
}

interface SidebarProps extends BoxProps {
  onClose: () => void;
}

const SidebarContent = ({ onClose, ...rest }: SidebarProps) => {

  return (
    <Box
      transition="3s ease"
      bg={useColorModeValue('#b3d7ff', 'gray.900')}
      borderRight="1px"
      borderRightColor={useColorModeValue('gray.200', 'gray.700')}
      w={{ base: 'full', md: 60 }}
      pos="fixed"
      h="full"
      {...rest}>
      <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
        <Image src='./textlogo.png' />

        <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} />
      </Flex>
      {LinkItems.map((link) => (
        <NavItem key={link.name} route={link.route} icon={link.icon}>
          {link.name}
        </NavItem>
      ))}
    </Box>
  );
};

interface NavItemProps extends FlexProps {
  icon: IconType;
  children: ReactText;
  route: string;
}
const NavItem = ({ icon, children, route, ...rest }: NavItemProps) => {
  const commonContext = React.useContext<CommonContextInterface>(CommonContext);


  return (
    <Link href={route} style={{ textDecoration: 'none' }} _focus={{ boxShadow: 'none' }}>
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        bg={commonContext.currentPage === route.replaceAll("/", "").toLowerCase() ? "cyan.100" : "transparent"}
        _hover={{
          bg: 'cyan.400',
          color: 'white',
        }}
        {...rest}>
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            _groupHover={{
              color: 'white',
            }}
            as={icon}
          />
        )}
        {children}
      </Flex>
    </Link>
  );
};

interface MobileProps extends FlexProps {
  onOpen: () => void;
}
const MobileNav = ({ onOpen, ...rest }: MobileProps) => {


  const [isOpenLogout, setIsOpenLogout] = React.useState(false)
  const focus = React.useRef(null)
  const commonContext = React.useContext<CommonContextInterface>(CommonContext);

  return (


    <Flex

      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 4 }}
      height="20"
      alignItems="center"
      bg={useColorModeValue('#e6f2ff', 'gray.900')}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      justifyContent={{ base: 'space-between', md: 'flex-center' }}
      {...rest}>
      <Text ml="100px" fontSize="3xl" className='adlam-font' fontWeight="bold">
        {commonContext.currentPath}
      </Text>
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
      />

      <Text
        display={{ base: 'flex', md: 'none' }}
        fontSize="2xl"
        fontFamily="sans serif"
        fontWeight="bold">
        Logo
      </Text>

      <HStack spacing={{ base: '0', md: '6' }}>
        <IconButton
          size="lg"
          variant="ghost"
          aria-label="open menu"
          icon={<FiBell />}
        />

        <Flex alignItems={'center'}>

          <Menu>
            <MenuButton
              py={2}
              transition="all 0.3s"
              _focus={{ boxShadow: 'none' }}>
              <HStack>
                <Avatar
                  size={'sm'}
                  src={
                    './logo_trans.png'
                  }
                />
                <VStack
                  display={{ base: 'none', md: 'flex' }}
                  alignItems="flex-start"
                  spacing="1px"
                  ml="2">
                  <Text fontSize="sm">Lorenzo</Text>
                  <Text fontSize="xs" color="gray.600">
                    Admin
                  </Text>
                </VStack>
                <Box display={{ base: 'none', md: 'flex' }}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList
              bg={useColorModeValue('white', 'gray.900')}
              borderColor={useColorModeValue('gray.200', 'gray.700')}>
              {/*  <MenuItem>Profile</MenuItem>
              <MenuItem>Settings</MenuItem>
              <MenuItem>Billing</MenuItem>
              <MenuDivider /> */}
              <MenuItem onClick={() => {
                setIsOpenLogout(true)

              }}>Logout</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
      <AlertDialog
        leastDestructiveRef={focus}
        isOpen={isOpenLogout}
        onClose={() => {
          setIsOpenLogout(false)
        }}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Logout
            </AlertDialogHeader>

            <AlertDialogBody>
              Vuoi effettuare il logout?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                w="60px"
                onClick={() => {
                  setIsOpenLogout(false)
                }}>
                No
              </Button>
              <Button
                w="60px"
                colorScheme='red'
                onClick={() => {
                  setIsOpenLogout(false)
                  localStorage.removeItem('token');
                  localStorage.removeItem('currentUser');
                  window.location.href = "/";
                }}
                ml={3}>
                Si
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );
};
